import e from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import x from "./iconfont.es5471.js";
const d = {
  display: "block"
}, f = ({ size: a = 16, useVw: t, useRem: l, color: c, withColor: o, removeClassName: n, disableSSR: p, style: i, ...m }) => {
  const h = i ? { ...d, ...i } : d;
  return /* @__PURE__ */ e.createElement(x, { disableSSR: p }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "32px-yanshengpin", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: t ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (l ? "rem" : "px"), height: t ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (l ? "rem" : "px"), className: n ? "" : "iconpark-icon", style: h, fill: "none", ...m }, /* @__PURE__ */ e.createElement(
    "g",
    {
      className: n ? "" : "32px-è¡çå"
    },
    /* @__PURE__ */ e.createElement(
      "g",
      {
        className: n ? "" : "normal",
        clipRule: "evenodd",
        fillRule: "evenodd",
        fill: o ? r(c, 0, "#262933") : "#262933",
        datafollowfill: o ? r(c, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M19.767 10.495c-.454-.995-1.867-.995-2.32 0l-.92 2.012-2.198.252c-1.086.125-1.522 1.468-.717 2.207l1.63 1.496-.44 2.169c-.216 1.07.926 1.901 1.878 1.364l1.927-1.088 1.926 1.088c.952.537 2.095-.293 1.877-1.364l-.44-2.169 1.63-1.496c.806-.739.37-2.082-.716-2.207l-2.198-.252-.92-2.012Zm-1.893 3.155.733-1.603.732 1.603a.85.85 0 0 0 .676.492l1.751.2-1.298 1.192a.85.85 0 0 0-.259.795l.35 1.728-1.535-.867a.85.85 0 0 0-.836 0l-1.534.867.35-1.727a.85.85 0 0 0-.259-.796l-1.299-1.192 1.752-.2a.85.85 0 0 0 .676-.492Z"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M12.103 4a3.407 3.407 0 0 0-3.408 3.407v6.761H6.704A2.604 2.604 0 0 0 4.1 16.772v6.037a5.205 5.205 0 0 0 4.595 5.169V28h.24c.105.007.21.012.315.013A.906.906 0 0 0 9.41 28h15.182a3.407 3.407 0 0 0 3.407-3.407V7.407A3.407 3.407 0 0 0 24.592 4h-12.49Zm12.489 1.8h-12.49c-.887 0-1.607.72-1.607 1.607V26.2h14.097c.887 0 1.607-.72 1.607-1.607V7.407c0-.887-.72-1.607-1.607-1.607ZM6.704 15.968h1.991v10.19a3.405 3.405 0 0 1-2.795-3.35v-6.036c0-.444.36-.804.804-.804Z"
        }
      )
    )
  )));
}, E = f;
export {
  E as default
};
